import { Component, inject } from '@angular/core';
import { EEntityType, ERelationType } from '@web/dtos';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';

@Component({
  selector: 'aw-shopping-cart-empty',
  imports: [FilterTextsPipe, LanguagePipe],
  templateUrl: './shopping-cart-empty.html',
})
export class ShoppingCartEmpty {
  protected readonly textStore: WebTextStore = inject(WebTextStore);
  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );

  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
}
